import { UnlayerOptions } from 'react-email-editor';
import {
  AllMergeTagsAndSpecialLinks,
  EmailTemplateType,
  EventType,
  TemplateTagResponseDTO,
} from './email-template-service.types';

export const defaultTags = (): {
  [key in EmailTemplateType]: key extends 'EVENT'
    ? {
        [key in EventType]: {};
      }
    : {};
} => ({
  EVENT: {
    OFFER_DISTRIBUTION: {},
    VERIFY_EMAIL: {},
    USER_PASSWORD_RESET: {},
    TABLET_APP_MESSAGES: {},
    ADMIN_PASSWORD_RESET: {},
    POINTS_EXPIRY_NOTIFICATION: {},
    GIFT_CARD_FAILED: {},
    COMP_GIFT_CARD_FAILED: {},
    ORDER_FAILURE_NOTIFIER: {},
    GIFT_CARD_EMAIL_RECEIPT: {},
    GIFTCARD_PURCHASE: {},
    EMAIL_GIFTCARD_PURCHASE_RECEIPT: {},
    EMAIL_GIFTCARD_ADD_VALUE_RECEIPT: {},
    EMAIL_GIFTCARD_BALANCE_REPORT_EXPORT_SUCCESS: {},
    EMAIL_GIFTCARD_BALANCE_REPORT_EXPORT_FAILED: {},
    EMAIL_GIFTCARD_ADD_VALUE: {},
  },
  OFFER: {},
  LOYALTY_OFFER: {},
  MESSAGE: {},
});

export const transformTags = (
  response: TemplateTagResponseDTO[],
): AllMergeTagsAndSpecialLinks => {
  const merge = response.filter(tag => !tag.specialLink);
  const requiredMerge = response.filter(
    tag => !tag.specialLink && tag.required,
  );
  const special = response.filter(tag => tag.specialLink);
  const requiredSpecial = response.filter(
    tag => tag.specialLink && tag.required,
  );

  const mergeTags = merge.reduce(
    (acc, item) => {
      const jsonTag: UnlayerOptions['mergeTags'][string] = JSON.parse(item.tag);

      if (item.type === 'EVENT') {
        acc[item.type][item.eventType] = {
          ...acc[item.type][item.eventType],
          [jsonTag.name]: jsonTag,
        };
      } else {
        acc[item.type] = {
          ...acc[item.type],
          [jsonTag.name]: jsonTag,
        };
      }

      return acc;
    },
    { ...defaultTags() },
  );

  const requiredMergeTags = requiredMerge.reduce(
    (acc, item) => {
      const jsonTag: UnlayerOptions['mergeTags'][string] = JSON.parse(item.tag);

      if (item.type === 'EVENT') {
        acc[item.type][item.eventType] = {
          ...acc[item.type][item.eventType],
          [jsonTag.name]: jsonTag,
        };
      } else {
        acc[item.type] = {
          ...acc[item.type],
          [jsonTag.name]: jsonTag,
        };
      }

      return acc;
    },
    { ...defaultTags() },
  );

  const specialLinks = special.reduce(
    (acc, item) => {
      const jsonTag: UnlayerOptions['mergeTags'][string] = JSON.parse(item.tag);

      if (item.type === 'EVENT') {
        acc[item.type][item.eventType] = {
          ...acc[item.type][item.eventType],
          [jsonTag.name]: {
            name: jsonTag.name,
            href: jsonTag.value,
            target: '_blank',
          },
        };
      } else {
        acc[item.type] = {
          ...acc[item.type],
          [jsonTag.name]: {
            name: jsonTag.name,
            href: jsonTag.value,
            target: '_blank',
          },
        };
      }

      return acc;
    },
    { ...defaultTags() },
  );

  const requiredSpecialLinks = requiredSpecial.reduce(
    (acc, item) => {
      const jsonTag: UnlayerOptions['mergeTags'][string] = JSON.parse(item.tag);

      if (item.type === 'EVENT') {
        acc[item.type][item.eventType] = {
          ...acc[item.type][item.eventType],
          [jsonTag.name]: {
            name: jsonTag.name,
            href: jsonTag.value,
            target: '_blank',
          },
        };
      } else {
        acc[item.type] = {
          ...acc[item.type],
          [jsonTag.name]: {
            name: jsonTag.name,
            href: jsonTag.value,
            target: '_blank',
          },
        };
      }

      return acc;
    },
    { ...defaultTags() },
  );

  return {
    mergeTags,
    requiredMergeTags,
    specialLinks,
    requiredSpecialLinks,
  };
};
